import {
  Http
} from '@/model/Http.js'

export default class member extends Http {
  //会员列表
  getUserList(data) {
    const url = 'api/user/search'
    return this.postAjax(url, {
      ...data
    })
  }

  //会员详情
  getUserInfo(data) {
    const url = 'api/user/get'
    return this.postAjax(url, {
      ...data
    })
  }

  //设置总监-缺少推荐人的情况
  updateWithoutMajor(data) {
    const url = 'api/user/update-major'
    return this.postAjax(url, {
      ...data
    })
  }
  //设置为总监-有推荐人的情况
  updateWithMarjor(data){
      const url = 'api/user/update'
      return this.postAjax(url, {
          ...data
      })
  }

  //二级团队
  userQueryAccess(data) {
    const url = 'api/user/query-access'
    return this.postAjax(url, {
      ...data
    })
  }

  //直推团队
  userQueryDirect(data) {
    const url = 'api/user/query-direct'
    return this.postAjax(url, {
      ...data
    })
  }
  // 是否有下级
   userQueryJunior(data){
    const url = 'api/user/query-junior'
    return this.postAjax(url, {
       ...data
    })
   }

  // 取消总监
  userCancelJunior(data){
    const url = 'api/user/cancel-major'
    return this.postAjax(url, {
      ...data
    })
  }

  // 生成二维码
  createQrcode(data){
    const url = 'api/user/get-qrcode'
    return this.postAjax(url, {
      ...data
    })
  }
}



// WEBPACK FOOTER //
// ./src/javaApi/member.js